import { isPlatformNodeJS, asyncTimeout } from '@utils/common';
import { ThrobberVisibleState } from '../store.js';

let triggeredPrintProgramatically = false;
let hasBoundGlobalListener = false;
let onBeforePrintCallback;
function registerOnBeforePrintCallback(cb) {
  onBeforePrintCallback = cb;
}
function onPrintDialogTriggered() {
  triggeredPrintProgramatically = true;
  setTimeout(() => {
    triggeredPrintProgramatically = false;
  }, 1_000);
}

/**
 * Browsers do not allow for asynchronous 'beforeprint' callbacks. However,
 * this is strictly required by our printing algorithm, and as such we bind
 * events that allow us, in a best effort, to allow integrations to provide
 * async beforeprint callbacks.
 */
function bindGlobalEvents() {
  if (hasBoundGlobalListener || isPlatformNodeJS()) {
    return;
  }
  hasBoundGlobalListener = true;
  let triggeredPrintThroughAsyncHandler = false;

  /**
   * Escape hatch: In case we cannot properly execute our async handling of the
   * onBeforePrint event, then we must call our callback anyways in the hopes
   * that content becomes available before the print dialog is finalized.
   */
  const onBeforePrint = () => {
    if (triggeredPrintThroughAsyncHandler || triggeredPrintProgramatically || !onBeforePrintCallback) {
      return;
    }
    onBeforePrintCallback?.();
  };
  const onKeyDown = async evt => {
    const isTriggeringPrintForMac = evt.key === "p" && evt.metaKey && !evt.altKey && !evt.ctrlKey && !evt.shiftKey;
    const isTriggeringPrintForWindows = evt.key === "p" && evt.ctrlKey && !evt.metaKey && !evt.altKey && !evt.shiftKey;
    const isTriggeringPrint = isTriggeringPrintForMac || isTriggeringPrintForWindows;
    if (!onBeforePrintCallback || !isTriggeringPrint) {
      return;
    }
    evt.preventDefault();
    ThrobberVisibleState.current = true;
    try {
      await Promise.race([onBeforePrintCallback(), asyncTimeout(15_000)]);
    } catch (err) {
      console.warn(err);
    }
    triggeredPrintThroughAsyncHandler = true;

    // window.print() is not enough to trigger print reliably in Safari,
    // See https://stackoverflow.com/questions/31171099/window-print-does-not-work-in-safari
    try {
      if (!document.execCommand("print", false, undefined)) {
        window.print();
      }
    } catch {
      window.print();
    }
    ThrobberVisibleState.current = false;
    setTimeout(() => {
      triggeredPrintThroughAsyncHandler = false;
    }, 500);
  };
  window.addEventListener("keydown", onKeyDown);
  window.addEventListener("beforeprint", onBeforePrint);
}

export { bindGlobalEvents, onPrintDialogTriggered, registerOnBeforePrintCallback };
//# sourceMappingURL=_before-print.js.map
